import axios from "@/utils/request";
// 立即登录
export function isLogin(data) {
  return axios({
    url: `/venue-pc-api/authentication/passwordLogin`,
    method: "get",
    params: data,
  });
}

// 退出
export function signout(params) {
  return axios({
    url: `/venue-pc-api/authentication/logout`,
    method: "post",
    params,
  });
}
// 菜单权限
export function getUserPage() {
  return axios({
    url: `/venue-login-api/oauth2/self/getUserPage`,
    method: "post",
  });
}
// 子系统权限
export function getClientPageAuth(params) {
  return axios({
    url: `/venue-pc-api/authentication/getClientPageAuth`,
    method: "post",
    params,
  });
}
// 密码修改
export function updatePassword(data) {
  return axios({
    url: `/venue-pc-api/authentication/update/password`,
    method: "post",
    data,
  });
}
// code登录
export function codeLogin(data) {
  return axios({
    url: `/venue-pc-api/authentication/codeLogin`,
    method: "get",
    params: data,
  });
}
// code登录
export function getUserinfo(data) {
  return axios({
    url: `/venue-pc-api/authentication/getUserinfo`,
    method: "get",
    params: data,
  });
}
// 生成签到二维码，会返回二维码地址，识别二维码后是二维码id
export function generateQRCode(data) {
  return axios({
    url: `/venue-pc-api/pc/admin/sign/in/generateQRCode`,
    method: "POST",
    data,
  });
}
// 生成签离二维码，会返回二维码地址，识别二维码后是二维码id
export function generateLeaveQRCode(params) {
  return axios({
    url: `/venue-pc-api/pc/admin/sign/in/generateLeaveQRCode`,
    method: "POST",
    params,
  });
}
// 检查签到二维码是否使用，0则刷新二维码，1置灰遮挡，2不管
export function checkQrcode(params) {
  return axios({
    url: `/venue-pc-api/pc/admin/sign/in/checkQrcode`,
    method: "POST",
    params,
  });
}
// 统计数据（包含即将参加的会议数量，我预约的会议数量，我预约的活动数量，我的正在处理任务数量）
export function statisticsData(data) {
  return axios({
    url: `/venue-pc-api/pc/admin/home/statisticsData`,
    method: "POST",
    data,
  });
}
// 近期预约列表
export function recentAppointmentList(params) {
  return axios({
    url: `/venue-pc-api/pc/admin/home/recentAppointmentList`,
    method: "POST",
    params,
  });
}
// 待审核
export function aduitList(params) {
  return axios({
    url: `/venue-pc-api/pc/admin/home/my-apply`,
    method: "POST",
    params,
  });
}
// 常用场地
export function useSiteList(data) {
  return axios({
    url: `/venue-pc-api/pc/admin/home/my-use`,
    method: "POST",
    data,
  });
}
// 更新用户座位状态
export function updateUserStatus(data) {
  return axios({
    url: `/venue-pc-api/pc/admin/seat/update/user/status`,
    method: "POST",
    data,
  });
}
// 参与分析统计
export function attendanceStatistics(data) {
  return axios({
    url: `/venue-pc-api/pc/admin/home/attendance-statistics`,
    method: "POST",
    data,
  });
}
// 参与分析统计 明细
export function attendanceStatisticsList(data) {
  return axios({
    url: `/venue-pc-api/pc/admin/home/attendance-statistics-list`,
    method: "POST",
    data,
  });
}
// 参与分析统计 明细导出
export function attendanceStatisticsExport(data) {
  return axios({
    url: `/venue-pc-api/pc/admin/home/attendance-statistics-list-export`,
    method: "POST",
    responseType: "blob",
    data,
  });
}
